
import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';

import { CarouselComponent } from '../carousel.component';
import { BaseWidgetComponent } from '../../../../shared/base.component';

export interface ICarouselSettings {
    items: {
        mobile: number;
        tablet: number;
        desktop: number;
    }
}

@Component({
    selector: 'carousel-item',
    template: `

<div class="carousel-item"  widget (touchrelease)="tap()" [class.show]="model.show">
    <div class="content"
        [style.opacity]="((model.index || 0) - (model.offset || 0) < -1) || (model.index || 0) - (model.offset || 0) > (model.count || 7) ? 0 : ''">
        <ng-content></ng-content>
    </div>
</div>`,
    styles: [`carousel-item:host{display:inline-block;height:100%}.carousel-item{position:relative;overflow:hidden;pointer-events:none;min-width:20%;width:100%;height:100%}.content{position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:auto}.show{-webkit-transition:left .2s;transition:left .2s}`]
})
export class CarouselItemComponent extends BaseWidgetComponent implements OnInit {
    public parent: CarouselComponent;
    public model: { [name: string]: any } = {};

    constructor(private el: ElementRef, private renderer: Renderer2) {
        super();
    }

    public ngOnInit(): void {
        this.timeout('show', () => this.model.show = true);
    }

    public tap() {
        if (this.parent) {
            this.parent.tap(this.model.index);
        }
    }

    public updateWidth() {
        if (!this.el || !this.el.nativeElement) { return; }
        this.renderer.setStyle(this.el.nativeElement, 'width', `${this.model.width * 100}%`);
    }
}